import { Component, Input } from '@angular/core';

@Component({
  selector: 'pui-tab',
  templateUrl: 'tab.component.html'
})
export class PuiTabComponent {
  @Input() title: string;
  @Input() active = false;
}
